import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {BASE_URL1 } from "../utils/apiURL";
import { STATUS } from "../utils/status";

const initialState = {
  categories: [],
  categoriesStatus: STATUS.IDLE,
  categoriesError: null, // Nouveau champ pour les erreurs
  categoryProducts: [],
  categoryProductsStatus: STATUS.IDLE,
  categoryProductsError: null, // Nouveau champ pour les erreurs
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAsyncCategories.pending, (state) => {
        state.categoriesStatus = STATUS.LOADING;
        state.categoriesError = null; // Réinitialise l'erreur précédente
      })
      .addCase(fetchAsyncCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
        state.categoriesStatus = STATUS.SUCCEEDED;
      })
      .addCase(fetchAsyncCategories.rejected, (state, action) => {
        state.categoriesStatus = STATUS.FAILED;
        state.categoriesError = action.payload || "Une erreur est survenue.";
      })
      .addCase(fetchAsyncProductsOfCategory.pending, (state) => {
        state.categoryProductsStatus = STATUS.LOADING;
        state.categoryProductsError = null; // Réinitialise l'erreur précédente
      })
      .addCase(fetchAsyncProductsOfCategory.fulfilled, (state, action) => {
        state.categoryProducts = action.payload;
        state.categoryProductsStatus = STATUS.SUCCEEDED;
      })
      .addCase(fetchAsyncProductsOfCategory.rejected, (state, action) => {
        state.categoryProductsStatus = STATUS.FAILED;
        state.categoryProductsError =
          action.payload || "Une erreur est survenue.";
      });
  },
});

// Fonction pour récupérer les catégories
export const fetchAsyncCategories = createAsyncThunk(
  "categories/fetch",
  async (_, { rejectWithValue }) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL1}get/Category`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json(); // Récupération du message d'erreur

      return rejectWithValue(errorData.message || "Failed to fetch categories");
    }

    const data = await response.json();

    return data.categories;
  }
);

// Fonction pour récupérer les produits par ID de catégorie
export const fetchAsyncProductsOfCategory = createAsyncThunk(
  "category-products/fetch",
  async (categoryId, { rejectWithValue }) => {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${BASE_URL1}getProductsByCategory/${categoryId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();

      return rejectWithValue(errorData.message || "Failed to fetch products");
    }

    const data = await response.json();

    return data.products;
  }
);

export const getCategorierProductById = (state, productId) => {
  return state.category.categoryProducts.find(
    (product) => product.id === parseInt(productId)
  );
};

// Sélecteurs
export const getAllCategories = (state) => state.category.categories;
export const getAllProductsByCategory = (state) =>
  state.category.categoryProducts;
export const getCategoryProductsStatus = (state) =>
  state.category.categoryProductsStatus;
export const getCategoriesError = (state) => state.category.categoriesError;
export const getCategoryProductsError = (state) => state.category.categoryProductsError;


export default categorySlice.reducer;
